import { composeMessageUrl } from "./composeMessageUrl";
import { documentRequestUrl } from "./documentRequest";
import { documentRequestTemplateUrl } from "./documentRequestTemplate";

export class SSE {
    static readonly COMPOSE_MESSAGE = new composeMessageUrl();
    static readonly DOCUMENT_REQUEST = new documentRequestUrl();
    static readonly DOCUMENT_REQUEST_TEMPLATE = new documentRequestTemplateUrl();
}